module.exports = __webpack_public_path__ + "img/asset.60e2c993.png";